import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Divider,   CircularProgress, Grid, Card, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, } from '@mui/material';
import { Link } from 'react-router-dom';

import { Stack } from '@mui/system';
import { useForm } from 'react-hook-form';
import axios from "axios";

import creditcardimg from './../assets/images/Dummycreditcard2.png'

const MyCardDetails = ({amount,subscription_id, type, id, callbackFunction, orderid }) => {
    document.title = "Avatar Chatbots - Add Funds to your account"
    const [openModal, setOpenModal] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { register, handleSubmit, formState: { errors, }, setError, trigger, setValue } = useForm({});
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    let obj = {};
    for (let pair of params.entries()) {
        obj[pair[0]] = pair[1]
    }
    const [errormes, seterrormes]= useState()
    const signUpAction = (data) => {
        seterrormes("")
        let userinfo = JSON.parse(sessionStorage.getItem('user-info'))
        let user_id = userinfo.id
        setIsSubmitting(true)
        let req = {
            card_number: data.card_number,
            expiry_date: data.expiry_year + "-" + data.expiry_month,
            cvv_code: data.CVV,
            description: data.description,
            email: data.emailAddress,
            address: data.address,
            city: data.city,
            state: data.state,
            zip: data.zip,
            country: data.country,
            user_id: user_id,
            selected_plan_id:id,
            user_current_subscription_id:subscription_id,
            
            type:type,
            order_id:orderid
             
        }
        console.log(req)
        axios.defaults.headers.common = { 'Authorization': `Bearer ${sessionStorage.getItem("Admintoken")}` }
        axios.post(`/apiV1/upgrade-subscription/`, req).then((rep) => {
            setIsSubmitting(false)
            setOpenModal(true)
        }
        ).catch((e) => {
            setIsSubmitting(false)
            if (e.response.data.message) {
                seterrormes(e.response.data.message)
            }
        })
    }
    const userinfo = JSON.parse(sessionStorage.getItem('user-info'));
    useEffect(() => {
        if (userinfo) {
            setValue("emailAddress", userinfo.email);
        }
    }, [setValue]);

    return (
        <>

{isSubmitting && (
                        <div className="screenLoader" style={{height:"85vh"}}>
                            <div className='text-center' style={{ marginTop: "10%" }}>
                                <div className='spinner-grow text-primary' role='status'>
                                    <span className='sr-only'>Loading...</span>
                                </div>
                            </div>
                        </div>
                    )}
            <Box component="form" onSubmit={handleSubmit(signUpAction)} noValidate sx={{ mt: 1, pt: 5 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12} lg={6} xl={6}  >
                        <Card style={{ padding: "10px" }}>
                            <Box >
                                <Typography variant='h4'>Address Details</Typography>
                            </Box>
                            <Divider sx={{ mb: 3 }} />
                            <Stack mb={3}>

                                <Grid container spacing={{ lg: 2 }}>
                                    <Grid item lg={12}>
                                        <label htmlFor="address" mt={1} mb={1}>Address </label>
                                        <input type="text" className="form-control" id="address" placeholder="Address"  {...register("address", { required: "This field is required", })}
                                            onKeyUp={() => { trigger("address"); }} />
                                        {errors.address && (<small className='text-danger font-bold'> {errors.address.message} </small>)}
                                    </Grid>
                                    <Grid item lg={6}>
                                        <label htmlFor="city" mt={1} mb={1}>City </label>
                                        <input type="text" className="form-control" id="city" placeholder="City"  {...register("city", { required: "This field is required", pattern: { value: /^[A-Za-z][A-Za-z-\s]+$/, message: "Please enter a valid city", }, })}
                                            onKeyUp={() => { trigger("city"); }} />
                                        {errors.city && (<small className='text-danger font-bold'> {errors.city.message} </small>)}
                                    </Grid>
                                    <Grid item lg={6}>
                                        <label htmlFor="state" mt={1} mb={1}>State </label>
                                        <input type="text" className="form-control" id="state" placeholder="State"  {...register("state", {
                                            required: "This field is required",
                                            pattern: {
                                                value: /^[A-Za-z][A-Za-z-\s]+$/,
                                                message: "Please enter a valid state",
                                            },

                                        })}
                                            onKeyUp={() => {
                                                trigger("state");

                                            }} />
                                        {errors.state && (<small className='text-danger font-bold'> {errors.state.message} </small>)}

                                    </Grid>
                                    <Grid item lg={6}>
                                        <label htmlFor="country" mt={1} mb={1}>Country </label>
                                        <input type="text" className="form-control" id="country" placeholder="Country"   {...register("country", {
                                            required: "This field is required",
                                            pattern: {
                                                value: /^[A-Za-z][A-Za-z-\s]+$/,
                                                message: "Please enter a valid country",
                                            }
                                        })}
                                            onKeyUp={() => {
                                                trigger("country");

                                            }} />
                                        {errors.country && (<small className='text-danger font-bold'> {errors.country.message} </small>)}

                                    </Grid>
                                    <Grid item lg={6}>
                                        <label htmlFor="zip" mt={1} mb={1}>Zip Code</label>
                                        <input type="number" className="form-control" id="zip" placeholder="zip"   {...register("zip", {
                                            required: "This field is required",
                                            pattern: {
                                                value: /^[0-9]+$/,
                                                message: "Please enter a valid name",
                                            },
                                            minLength: {
                                                value: 6,
                                                message: "Please enter min and max 6 characters ",
                                            },
                                            maxLength: {
                                                value: 6,
                                                message: "Please enter min and max  6 characters ",
                                            },
                                        })}
                                            onKeyUp={() => {
                                                trigger("zip");

                                            }} />
                                        {errors.zip && (<small className='text-danger font-bold'> {errors.zip.message} </small>)}
                                    </Grid>
                                    <Grid item lg={12} >
                                        <Divider />
                                    </Grid>
                                </Grid>



                                <label htmlFor="emailAddress" mt={1} mb={1}>Email </label>
                                {/* <TextField fullWidth variant="outlined" id="emailAddress" error={errors.emailAddress}
                                    helperText={errors.emailAddress ? errors.emailAddress.message : null}
                                    {...register("emailAddress", {
                                        required: "This field is required",
                                        pattern: {
                                            value:
                                                /^[A-Z0-9._%+-]+@[A-Z0-9.-]{2,}\.+[A-Z]{2,5}$/i,
                                            message: "Please enter a valid email address.",
                                        },
                                    })}
                                    onKeyUp={(e) => {
                                        trigger("emailAddress");
                                    }} /> */}
                                <input type="text" className="form-control" id="emailAddress" placeholder="emailAddress" readOnly={true}  {...register("emailAddress", {
                                    required: "This field is required",
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]{2,}\.+[A-Z]{2,5}$/i,
                                        message: "Please enter a valid email address.",
                                    },
                                })}
                                    value={userinfo ? userinfo.email : ''}
                                    onKeyUp={() => {
                                        trigger("emailAddress");
                                    }} />
                                {errors.emailAddress && (<small className='text-danger font-bold'> {errors.emailAddress.message} </small>)}

                                <label htmlFor="Description" mt={3} mb={1}>Description</label>
                                <input type="text" className="form-control" id="Description" placeholder="Description"  {...register("description", {
                                    required: "This field is required",
                                    pattern: {
                                        value: /^[A-Za-z0-9][A-Za-z0-9-\s]+$/,
                                        message: "Please enter a valid description",
                                    },
                                    minLength: {
                                        value: 3,
                                        message: "Please enter min 3 characters ",
                                    },
                                })}
                                    onKeyUp={() => {
                                        trigger("description");

                                    }} />
                                {errors.description && (<small className='text-danger font-bold'> {errors.description.message} </small>)}


                            </Stack>



                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={12} lg={6} xl={6}>

                        <Card style={{ padding: "10px" }}>
                            <Box textAlign={"center"}>
                                <Typography variant='h3'> Card Details</Typography>
                            </Box>

                            <Box textAlign={"center"} sx={{ m: 4 }}>
                                <img src={creditcardimg} alt="credit card" />
                            </Box>
                            <label htmlFor="card_number" mt={3} mb={1}>Card Number </label>
                            <input type="text" className="form-control" id="card_number" placeholder="Card number" maxLength={16} {...register("card_number", {
                                required: "This field is required",
                                pattern: {
                                    value: /^[0-9]+$/,
                                    message: "Please enter a card number",
                                },
                                minLength: {
                                    value: 16,
                                    message: "Please enter min 16 characters ",
                                },
                                maxLength: {
                                    value: 19,
                                    message: "Please enter min 19 characters ",
                                },

                            })}
                                onKeyUp={() => {
                                    trigger("card_number");

                                }} />
                            {errors.card_number && (<small className='text-danger font-bold'> {errors.card_number.message} </small>)}

                            <Grid container spacing={{ lg: 2 }}>
                                <Grid item lg={4} sx={{ mt: 2 }}>
                                    <label htmlFor="expiry_month" mt={1} mb={1}>Expiry Month</label>
                                    <select className="form-select" id="expiry_month"   {...register("expiry_month", { required: "Please select Expiry Month ", })}
                                        onKeyUp={() => { trigger("expiry_month"); }}
                                        onChange={() => {
                                            if (errors.expiry_month) {
                                                setError("expiry_month", { type: "custom", message: "" });
                                            }
                                        }} >
                                        <option value=''>Select Month</option>
                                        <option value='01'>Jan</option>
                                        <option value='02'>Feb</option>
                                        <option value='03'>Mar</option>
                                        <option value='04'>Apr</option>
                                        <option value='05'>May</option>
                                        <option value='06'>June</option>
                                        <option value='07'>Jul</option>
                                        <option value='08'>Aug</option>
                                        <option value='09'>Sep</option>
                                        <option value='10'>Oct</option>
                                        <option value='11'>Nov</option>
                                        <option value='12'>Dec</option>

                                    </select>

                                    {errors.expiry_month && (<small className='text-danger font-bold'> {errors.expiry_month.message} </small>)}


                                </Grid>
                                <Grid item lg={4} sx={{ mt: 2 }}>
                                    <label htmlFor="expiry_year" mt={1} mb={1}>Expiry Year  </label>
                                    <select className="form-select" id="expiry_year"   {...register("expiry_year", { required: "Please select expiry year", })}
                                        onKeyUp={() => { trigger("expiry_year"); }}
                                        onChange={() => {
                                            if (errors.expiry_year) {
                                                setError("expiry_year", { type: "custom", message: "" });
                                            }
                                        }}>
                                        <option value=''>Select Year</option>
                                        <option value='2024'>2024</option>
                                        <option value='2025'>2025</option>
                                        <option value='2026'>2026</option>
                                        <option value='2027'>2027</option>
                                        <option value='2028'>2028</option>
                                        <option value='2029'>2029</option>
                                        <option value='2030'>2030</option>
                                        <option value='2031'>2031</option>
                                        <option value='2032'>2032</option>
                                        <option value='2033'>2033</option>
                                        <option value='2034'>2034</option>
                                        <option value='2035'>2035</option>
                                        <option value='2036'>2036</option>
                                        <option value='2037'>2037</option>
                                        <option value='2038'>2038</option>
                                        <option value='2039'>2039</option>
                                        <option value='2040'>2040</option>

                                    </select>

                                    {errors.expiry_year && (<small className='text-danger font-bold'> {errors.expiry_year.message} </small>)}



                                </Grid>
                                <Grid item lg={4} sx={{ mt: 2 }}>
                                    <label htmlFor="CVV" mt={1} mb={1}>CVV</label>
                                    <input type="number" className="form-control" id="CVV" placeholder="CVV" {...register("CVV", {
                                        required: "This field is required",
                                        pattern: {
                                            value: /^[0-9]+$/,
                                            message:
                                                "Please enter min and max 3 digits",
                                        },
                                        minLength: {
                                            value: 3,
                                            message: "Please enter min and max 3 characters ",
                                        },
                                        maxLength: {
                                            value: 3,
                                            message: "Please enter min and max 3 characters ",
                                        }
                                    })}
                                        onKeyUp={() => {
                                            trigger("CVV");

                                        }} />
                                    {errors.CVV && (<small className='text-danger font-bold'> {errors.CVV.message} </small>)}

                                </Grid>

                            </Grid>
                            <div className="text-danger">{errormes}</div>
                        </Card>
                    </Grid>

                </Grid>
                <Box textAlign={"right"} sx={{ mt: 3 }}>
                <button type="button" onClick={()=> callbackFunction()} style={{ height: "40px", width: "initial",  background: " linear-gradient(to right,rgb(233, 6, 6),rgb(240, 32, 49))"  }} disabled={isSubmitting} className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                        <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }} >Cancel</span>
                    </button>

                    <button type="submit" style={{ height: "40px", width: "initial" }} disabled={isSubmitting} className="position-relative d-inline-flex align-items-center justify-content-center p-1  me-2 overflow-hidden text-sm greaditentbutton fw-medium text-dark rounded-lg border-0" >
                        <span className="position-relative px-4 py-2  rounded-md" style={{ transition: "0.3s" }} > Add Card</span>
                    </button>

                  

                </Box>
            </Box>
            <Dialog open={openModal} onClose={() => setOpenModal(false)} disableEscapeKeyDown onBackdropClick >
                <DialogTitle>Order</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Your subscription was successfully created
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={()=>callbackFunction()} color="primary"> OK </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
export default MyCardDetails;
